<template>
  <div>
    <b-navbar
      class="topNav"
      type="light">
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto pt-3 mr-4">
        <b-nav-item href="/">Join a Meeting</b-nav-item>
        <b-nav-item
          v-if="!isMobile()"
          href="/#/download/">{{ $t('LOGIN.DOWNLOAD') }}</b-nav-item>
        <b-nav-item href="https://rhelp.corenexa.com/Video">{{ $t('LOGIN.SUPPORT') }}</b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <b-container fluid>
      <b-row
        align-h="center"
        class="pb-5">
        <b-col
          v-if="isSupported()"
          cols="12"
          sm="10"
          md="8"
          lg="5"
          xl="4"
          class="mt-sm-5 loginMaxWidth">
          <b-form
            class="bg-white p-4 rounded shadow light login mt-2"
            @submit="onSubmit"
          >
            <div class="mx-auto my-md-4 text-center logoSize">
              <logo/>
            </div>
            <h3 class="text-center mt-1 mb-5 downloadText">Download Desktop App</h3>
            <h5 class="text-center mt-4 mb-2 downloadText">After the installer package downloads,<br>click on it to start installation.</h5>
            <hr> 
            <div class="text-center">
              <b-button
                class="ml-auto d-block"
                variant="primary-light"
                href="https://content.corenexa.com/packages/prod/installers/corenexa_windows_64bits_5_00_6010.exe"
              >Download for Windows</b-button>
              <br>
              <b-button 
                class="ml-auto d-block"
                variant="primary-light"
                href="https://content.corenexa.com/packages/prod/installers/corenexa_macos_5_00_6010.dmg"
              >Download for Mac</b-button>
              <br>          
              <b-button
                class="ml-auto d-block"
                variant="primary-light"
                href="https://content.corenexa.com/packages/prod/installers/corenexa_linux_64bits_5_00_6010.sh"
              >Download for Linux</b-button>
            </div>
          </b-form>
        </b-col>
        <b-col
          v-else
          cols="12"
          sm="10"
          md="8"
          lg="5"
          xl="4"
          class="mt-sm-5"
        >
          <div class="bg-white p-4 rounded shadow text-danger-light login mt-2 text-center">
            <div class="m-4">
              <logo/>
            </div>
            <p v-if="isMobile()">{{ $t('LOGIN.MOBILE_UNSUPPORTED') }}</p>
            <p v-if="!isMobile()">{{ $t('LOGIN.BROWSER_UNSUPPORTED') }}</p>
          </div>
        </b-col>
      </b-row>
      <div class="footer clearfix">
        <div class="float-left"><small>© {{ new Date().getFullYear() + " " + $t('LOGIN.COPYRIGHTS') }}</small></div>
        <div class="float-right"><a
          target="_blank"
          href="https://www.corenexa.com/privacy-policy">{{ $t('LOGIN.PRIVACY_POLICY') }}</a></div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { getBrowser, isSupported, isMobile, isIos } from "../functions/browserDetails"
import { loadStorageData, getItem, setItem, getMetaToken, saveMetaToken, getCorenexaToken } from "../functions/storageManager"
import { ref, reactive, watch, onMounted } from "@vue/composition-api"
import Logo from "../icons/Logo"

export default {
  name: 'Browser',
  components: {
    Logo
  },
  setup(props, context) {
    const meetingIds = ref([])
    const language = ref('en')
    const languageName = ref('English')
    const languages = ref([{value:"en",name:"English"},{value:"fr",name:"Français"},{value:"sk",name:"Slovenčina"},{value:"es",name:"Español"},{value:"ro",name:"Româna"},{value:"it",name:"Italiano"},{value:"pt",name:"Português"},{value:"de",name:"Deutsch"},{value:"fi",name:"Suomi"},{value:"tr",name:"Türkçe"},{value:"nl",name:"Nederlands"},{value:"zh",name:"简体中文"},{value:"ru",name:"Русский"},{value:"ar",name:"لغة"},{value:"el",name:"Ελληνικά"},{value:"ko",name:"한국어}"},{value:"ja",name:"日本語"},{value:"ur",name:"زبان"},{value:"ne",name:"भाषा"},{value:"kk",name:"Қазақтілі"},{value:"hi",name:"हिन्दी"}])
    const meta_token = ref('');
    const form = reactive ({
      meetingID: '',
      name: '',
      pin: '',
      directly: false
    })
    document.body.style.backgroundColor = "#f8f8f8";

    const browser = getBrowser()
    loadStorageData()
    if (getItem('meetings')) {
      meetingIds.value = getItem('meetings').split(",")
    }
    if (getItem('language') !== undefined) {
      context.root.$i18n.locale = getItem('language')
    } else if (context.root.$route.query.language) {
      context.root.$i18n.locale = context.root.$route.query.language
    } else if (window.default_language != "") {
      context.root.$i18n.locale = window.default_language
    }

    if (getItem('languageName') !== undefined) {
      languageName.value = getItem('languageName')
    } else if (window.default_language != "") {
      languageName.value = window.default_languageName
    }
    language.value = context.root.$i18n.locale





    
    onCreate(context)
return
    function onCreate(context) {
      joinMeeting()   
      return   
    }
  
    function onSubmit (evt) {
      evt.preventDefault()
    }

    async function joinMeeting() {

      const userName = context.root.$route.query.userName;
      const meetingID = context.root.$route.query.meetingID;
      const pin = context.root.$route.query.pin;

      const nameParam = userName ? '&name=' + encodeURIComponent(userName) : '';
      const pinParam = pin ? '&pin=' + pin : '';

      const locationURL = `https://meeting.corenexa.com/?action=join&meetingID=${meetingID}${nameParam}${pinParam}`;
      location.replace(locationURL);
    //location.replace('https://meeting.corenexa.com/?action=join&meetingID='+context.root.$route.query.meetingID+'&pin='+context.root.$route.query.pin)    
    }

    function changeLanguage (value, name) {
      context.root.$i18n.locale = value
      languageName.value = name
      setItem('language', value)
      setItem('languageName', name)
    }
    watch(() => form.directly, (directly) => { setItem('directly', directly) })
    return {
      language,
      changeLanguage,
      form,
      meetingIds,
      browser,
      isSupported,
      isMobile,
      loadStorageData,
      getItem,
      setItem,
      onSubmit,
      languages,
      languageName,
      meta_token
    }
  }
}
</script>
<style scoped>
.topNav {
  font-size: 12px;
  padding: .75rem .75rem;
  background-color: transparent!important;
  box-shadow: none!important;
}
.login hr {
  margin: 32px -25px 16px;
}
.logo{
  max-width: 200px;
  line-height: 1;
}
.topNav {
  font-weight: 600;
  padding: 0;
}
.navbar-toggler-icon {
  color: #000000;
}

</style>



// WEBPACK FOOTER //
// src/components/Browser.vue